export function useCurrentOrigin() {
  const site = useSiteConfig()
  // TODO These are supposed to be the same, so in theory we should be able to use `site.url` everywhere, but for i.e. the Netlify branches they are not. We should fix it with env variables.
  return import.meta.client ? window.location.origin : site.url
}
